import { render, staticRenderFns } from "./ComplexChallengeSettings.vue?vue&type=template&id=54b8f199"
import script from "./ComplexChallengeSettings.vue?vue&type=script&lang=js"
export * from "./ComplexChallengeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports